import Modal from 'react-modal';
import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { alertaGeneral } from '../../utils/alertas';
import BotonSubmitEpayco from '../ePayco/BotonSubmitEpayco';
import apiClient from '../../utils/axiosPetition';
import Cargando from '../../utils/Cargando';
import { FaArrowLeft, FaBookOpen, FaChevronRight } from 'react-icons/fa';
import { APP_URLS } from '../../config/appUrls';

Modal.setAppElement('#root');

const Cursos = () => {
    const { nombreAfiliado } = useParams();
    const [cargando, setCargando] = useState(true);
    const [cursos, setCursos] = useState([]);
    const [cursoSeleccionado, setCursoSeleccionado] = useState(null);
    const [correo] = useState(localStorage.getItem('doctorEmail'));
    const [precioCurso, setPrecioCurso] = useState(null);

    const nombreDisplay = nombreAfiliado ? String(nombreAfiliado).charAt(0).toUpperCase() + String(nombreAfiliado).slice(1).toLowerCase() : '';

    useEffect(() => {
        if (!nombreAfiliado) return;
        apiClient.get(`/api/cursos/getCursos/${nombreAfiliado.toUpperCase()}`)
            .then(res => {
                setCursos(Array.isArray(res.data) ? res.data : []);
            })
            .catch(() => {
                alertaGeneral({
                    titulo: "Error",
                    messageHtml: "Ocurrió un error al cargar los cursos",
                    isError: true
                });
                setCursos([]);
            })
            .finally(() => setCargando(false));
    }, [nombreAfiliado]);

    useEffect(() => {
        apiClient.get('/api/precios')
            .then(res => {
                const precio = res.data?.find(s => s.nombre?.toLowerCase().includes('curso'));
                setPrecioCurso(precio?.valor ?? 0);
            })
            .catch(() => setPrecioCurso(0));
    }, []);

    const handleVerMas = (curso) => setCursoSeleccionado(curso);
    const cerrarModal = () => setCursoSeleccionado(null);

    if (cargando) {
        return <Cargando />;
    }

    return (
        <div className="min-h-[60vh] bg-gradient-to-b from-slate-50 to-white">
            {/* Navegación y encabezado */}
            <div className="bg-white border-b border-slate-200 shadow-sm">
                <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4">
                    <Link
                        to=".."
                        className="inline-flex items-center gap-2 text-[#205087] hover:text-[#1f94c2] font-medium text-sm mb-4 transition-colors"
                    >
                        <FaArrowLeft className="w-4 h-4" />
                        Volver a Beneficios / Aliados
                    </Link>
                    <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                        <div className="grid place-items-center w-12 h-12 min-w-[3rem] min-h-[3rem] rounded-xl bg-gradient-to-br from-[#1f94c2] to-[#205087] text-white shadow-lg shrink-0">
                            <FaBookOpen className="w-6 h-6 block" aria-hidden />
                        </div>
                        <div>
                            <h1 className="text-xl sm:text-2xl font-bold text-slate-800">
                                Cursos {nombreDisplay}
                            </h1>
                            <p className="text-slate-500 text-sm sm:text-base mt-0.5">
                                Elige un curso, revisa los detalles e inscríbete
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contenido principal */}
            <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
                {cursos.length === 0 ? (
                    <div className="text-center py-16 bg-white rounded-2xl border border-slate-200 shadow-sm">
                        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-slate-100 text-slate-400 mb-4">
                            <FaBookOpen className="w-8 h-8" />
                        </div>
                        <h2 className="text-lg font-semibold text-slate-700 mb-2">
                            No hay cursos disponibles
                        </h2>
                        <p className="text-slate-500 text-sm max-w-sm mx-auto">
                            No hay cursos del aliado {nombreDisplay} en este momento. Revisa más tarde o vuelve al listado de aliados.
                        </p>
                        <Link
                            to=".."
                            className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 bg-[#205087] text-white rounded-lg hover:bg-[#1f94c2] transition-colors text-sm font-medium"
                        >
                            <FaArrowLeft className="w-4 h-4" />
                            Ver aliados
                        </Link>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {cursos.map((curso, index) => (
                            <article
                                key={curso._id || index}
                                className="group bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm hover:shadow-xl hover:border-[#1f94c2]/30 transition-all duration-300"
                            >
                                <div className="relative aspect-[4/3] bg-slate-100 overflow-hidden">
                                    {curso.urlBanner ? (
                                        <img
                                            src={curso.urlBanner}
                                            alt={curso.nombre || 'Curso'}
                                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                                        />
                                    ) : (
                                        <div className="w-full h-full flex flex-col items-center justify-center text-slate-400 p-4">
                                            <FaBookOpen className="w-12 h-12 mb-2 opacity-50" />
                                            <span className="text-xs text-center">Sin imagen</span>
                                        </div>
                                    )}
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                                </div>
                                <div className="p-4">
                                    <h3 className="font-semibold text-slate-800 line-clamp-2 min-h-[2.5rem]" title={curso.nombre}>
                                        {curso.nombre || 'Curso'}
                                    </h3>
                                    <button
                                        type="button"
                                        onClick={() => handleVerMas(curso)}
                                        className="mt-3 w-full inline-flex items-center justify-center gap-2 py-2.5 px-4 rounded-xl bg-[#1f94c2] text-white text-sm font-medium hover:bg-[#205087] transition-colors"
                                    >
                                        Ver detalles e inscribirme
                                        <FaChevronRight className="w-4 h-4" />
                                    </button>
                                </div>
                            </article>
                        ))}
                    </div>
                )}
            </div>

            {/* Modal detalle e inscripción */}
            <Modal
                isOpen={!!cursoSeleccionado}
                onRequestClose={cerrarModal}
                className="relative w-[95%] max-w-lg mx-auto mt-[10vh] bg-white rounded-2xl shadow-2xl border border-slate-200 focus:outline-none overflow-hidden"
                overlayClassName="fixed inset-0 flex items-start justify-center bg-black/50 backdrop-blur-sm z-[100] overflow-y-auto py-8"
            >
                {cursoSeleccionado && (
                    <>
                        <div className="relative max-h-[40vh] bg-slate-100">
                            {cursoSeleccionado.urlImage || cursoSeleccionado.urlBanner ? (
                                <img
                                    src={cursoSeleccionado.urlImage || cursoSeleccionado.urlBanner}
                                    alt={cursoSeleccionado.nombre}
                                    className="w-full h-full object-contain max-h-[40vh]"
                                />
                            ) : (
                                <div className="flex flex-col items-center justify-center py-16 text-slate-400">
                                    <FaBookOpen className="w-16 h-16 mb-2 opacity-50" />
                                    <span>{cursoSeleccionado.nombre}</span>
                                </div>
                            )}
                        </div>
                        <div className="p-6">
                            <h2 className="text-xl font-bold text-slate-800 mb-1">
                                {cursoSeleccionado.nombre}
                            </h2>
                            {precioCurso > 0 && (
                                <p className="text-2xl font-bold text-[#205087] mb-6">
                                    ${Number(precioCurso).toLocaleString('es-CO')} COP
                                </p>
                            )}
                            <div className="flex flex-col-reverse sm:flex-row gap-3">
                                <button
                                    type="button"
                                    onClick={cerrarModal}
                                    className="flex-1 py-3 px-4 rounded-xl border-2 border-slate-200 text-slate-700 font-medium hover:bg-slate-50 transition-colors"
                                >
                                    Cerrar
                                </button>
                                <div className="flex-1 flex justify-end">
                                    <BotonSubmitEpayco
                                        descripcion={`Pago Curso ${cursoSeleccionado.nombre}`}
                                        correo={correo}
                                        amount={precioCurso}
                                        invoice={cursoSeleccionado._id}
                                        redireccion={APP_URLS.resultadoCursoEpayco}
                                        extraData={{
                                            tipo: 'curso',
                                            cursoId: cursoSeleccionado._id,
                                            nombreCurso: cursoSeleccionado.nombre
                                        }}
                                        onClick={() => localStorage.setItem('cursoId', cursoSeleccionado._id)}
                                        disabled={!precioCurso}
                                    />
                                </div>
                            </div>
                            {!precioCurso && (
                                <p className="text-amber-600 text-sm mt-3">
                                    No se pudo cargar el precio. Intenta de nuevo más tarde.
                                </p>
                            )}
                        </div>
                    </>
                )}
            </Modal>
        </div>
    );
};

export default Cursos;
